import { memo, useContext, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  FilledInput,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@material-ui/icons";

import AppContext from "../contexts/AppContext";
import { setPageTitle } from "../actions";
import Header from "../components/header";
import CustomBox from "../components/templates/customBox";
import SearchList from "../components/search_list";
import IssuePagination from "../components/issue_pagination";
import componentStyles from "../assets/styles/containers/search";
import { useSearch } from "../hooks/useSearch";

const useStyles = makeStyles(componentStyles);
const Search = memo(() => {
  const { state, dispatch } = useContext(AppContext);
  const [word, setWord] = useState(state.search.word);
  const { loading, setLoading, readSearch, errors } = useSearch();
  const history = useHistory;
  const classes = useStyles(componentStyles);
  const { t } = useTranslation();

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      const userInfo = await Auth.currentUserInfo();
      if (userInfo) {
        setPageTitle(dispatch, t("label_search"));
      } else {
        history.push("/");
        await Auth.signOut();
      }
    }
    getCurrentAuthenticatedUser();
  }, []);

  useEffect(() => {
    if (!state.search.word) {
      setWord("");
    }
  }, [state.search]);

  const handleClickSearchButton = async () => {
    setLoading(true);
    readSearch(word);
  };

  const handleClickPageNumber = (page) => readSearch(word, page);

  const generateResultStats = () => {
    const start = state.search.offset + 1;
    const end = state.search.offset + state.search.limit;
    const total = state.search.total_count;
    const stats = ` ${start} - ${end > total ? total : end} / ${
      state.search.total_count
    }`;
    return stats;
  };

  return (
    <>
      <Header />
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12} md={12} lg={7}>
            <FormGroup>
              <FormControl
                variant="filled"
                component={Box}
                marginBottom="1rem!important"
              >
                <FilledInput
                  className={classes.searchInput}
                  value={word}
                  onChange={(e) => setWord(e.target.value)}
                  placeholder="キーワード"
                  fullWidth
                  endAdornment={
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickSearchButton}
                      onMouseDown={handleClickSearchButton}
                    >
                      <SearchOutlined />
                    </IconButton>
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      // エンターキー押下時の処理
                      handleClickSearchButton();
                    }
                  }}
                />
              </FormControl>
            </FormGroup>
          </Grid>
        </Grid>

        {state.search.results ? (
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              subheader={
                <Grid
                  container
                  component={Box}
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={1}
                >
                  <Grid item xs="auto">
                    <Box
                      component={Typography}
                      variant="h3"
                      marginBottom="0!important"
                    >
                      {`"${state.search.word}" の結果`}
                    </Box>
                  </Grid>
                  <Grid>
                    <Typography>
                      {!loading ? generateResultStats() : null}
                    </Typography>
                  </Grid>
                </Grid>
              }
            ></CardHeader>
            <CardContent>
              <CustomBox loading={loading} errors={errors}>
                <SearchList results={state.search.results} />
              </CustomBox>
            </CardContent>
            <IssuePagination
              limit={state.search.limit}
              offset={state.search.offset}
              total_count={state.search.total_count}
              handleClickPageNumberFunc={handleClickPageNumber}
            />
          </Card>
        ) : null}
      </Container>
    </>
  );
});

export default Search;
